import React from 'react'
import jabilLogo from '../asset/logo-jabil.svg'
import InlineLogo from '../components/InlineLogo'
import { getAssetUrl } from '../utils/asset'
import './AuthPages.css'

interface SignInPageProps {
  onSignIn: () => void
}

const SignInPage: React.FC<SignInPageProps> = ({ onSignIn }) => {
  const logoSrc = getAssetUrl(jabilLogo)

  return (
    <div className="auth-page auth-page--signin">
      <div className="auth-page__bg" />
      <div className="auth-card auth-card--signin">
        <div className="auth-card__logo">
          {logoSrc ? (
            <img src={logoSrc} alt="Jabil" className="auth-card__logo-img" />
          ) : (
            <InlineLogo className="auth-card__logo-svg" />
          )}
        </div>
        <div className="auth-card__accent" />
        <h1 className="auth-card__title">Agentic AI for True Shortage Validation</h1>
        <p className="auth-card__subtitle">Sign in with your organization account to continue.</p>
        <button type="button" className="auth-card__btn auth-card__btn--primary" onClick={onSignIn}>
          Sign in
        </button>
      </div>
    </div>
  )
}

export default SignInPage
